import React from "react";
import { Button } from "antd";

const CanvasHelpPanel = ({
    t,
    mode,
    aPressed,
    ctrlPressed,
    shiftPressed,
    showCanvasHelp,
    setShowCanvasHelp,
}) => {
    const getCurrentCanvasMode = () => {
        if (mode === "edit") return t("bbox.help.mode.edit");
        if (mode === "setting") return t("bbox.help.mode.setting");
        if (mode === "view") return t("bbox.help.mode.view");

        return t("bbox.help.mode.view");
    };

    const getCurrentCanvasModeDescription = () => {
        if (mode === "edit") {
            if (aPressed) return t("bbox.help.description.editRect");
            if (ctrlPressed) return t("bbox.help.description.editBbox");
            if (shiftPressed) return t("bbox.help.description.editLine");

            return t("bbox.help.description.edit");
        }

        if (mode === "setting") return t("bbox.help.description.setting");
        if (mode === "view") return t("bbox.help.description.view");

        return t("bbox.help.description.view");
    };
    const getCurrentCanvasModeColor = () => {
        if (mode === "edit") return "#52c41a";
        if (mode === "setting") return "#1677ff";
        if (mode === "view") return "#666";

        return "#666";
    };

    const getCurrentEditTool = () => {
        if (mode !== "edit") return null;

        if (aPressed) return t("bbox.help.tool.rect");
        if (ctrlPressed) return t("bbox.help.tool.bbox");
        if (shiftPressed) return t("bbox.help.tool.line");

        return t("bbox.help.tool.none");
    };

    return (
        <div
            style={{
                position: "absolute",
                right: 16,
                bottom: 10,
                zIndex: 30,
                display: "flex",
                alignItems: "flex-end",
                gap: 8,
                pointerEvents: "auto",
            }}
        >
            <Button
                size="small"
                onClick={() => setShowCanvasHelp((prev) => !prev)}
            >
                {showCanvasHelp ? t("bbox.help.hide") : t("bbox.help.show")}
            </Button>
            {showCanvasHelp && (
                <div
                    style={{
                        width: 320,
                        maxWidth: "calc(100vw - 40px)",
                        background: "rgba(255,255,255,0.94)",
                        border: "1px solid rgba(0,0,0,0.08)",
                        borderRadius: 12,
                        padding: 12,
                        boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
                        backdropFilter: "blur(6px)",
                        fontSize: 12,
                        lineHeight: 1.5,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: 8,
                        }}
                    >
                        <strong>{t("bbox.help.title")}</strong>
                        <span
                            style={{
                                background: getCurrentCanvasModeColor(),
                                color: "#fff",
                                borderRadius: 999,
                                padding: "2px 10px",
                                fontSize: 11,
                                fontWeight: 600,
                            }}
                        >
                            {getCurrentCanvasMode()}
                        </span>

                    </div>

                    <div style={{ marginBottom: 10, color: "#555" }}>
                        {getCurrentCanvasModeDescription()}
                    </div>

                    <div style={{ marginBottom: 10 }}>
                        <div style={{ fontWeight: 600, marginBottom: 4 }}>
                            {t("bbox.help.availableTitle")}
                        </div>
                        <ul style={{ margin: 0, paddingLeft: 18 }}>
                            {mode === "view" && (
                                <ul style={{ margin: 0, paddingLeft: 18 }}>
                                    <li>{t("bbox.help.available.pan")}</li>
                                    <li>{t("bbox.help.available.zoom")}</li>
                                    <li>{t("bbox.help.available.photoMove")}</li>
                                    <li>{t("bbox.help.available.hoverInfo")}</li>
                                    <li>{t("bbox.help.available.bboxList")}</li>
                                </ul>
                            )}
                            {mode === "setting" && (
                                <ul style={{ margin: 0, paddingLeft: 18 }}>
                                    <li>{t("bbox.help.available.brightness")}</li>
                                    <li>{t("bbox.help.available.contrast")}</li>
                                    <li>{t("bbox.help.available.sharpness")}</li>
                                    <li>{t("bbox.help.available.overlayToggle")}</li>
                                    <li>{t("bbox.help.available.colorAndLine")}</li>
                                </ul>
                            )}
                            {mode === "edit" && (
                                <ul style={{ margin: 0, paddingLeft: 18 }}>
                                    <li>{t("bbox.help.available.pan")}</li>
                                    <li>{t("bbox.help.available.zoom")}</li>
                                    <li>{t("bbox.help.available.editObjects")}</li>
                                    <li>{t("bbox.help.available.bboxCreate")}</li>
                                    <li>{t("bbox.help.available.lineMeasure")}</li>
                                    <li>{t("bbox.help.available.rectMeasure")}</li>
                                </ul>
                            )}
                        </ul>
                    </div>
                    <div style={{ borderTop: "1px solid #e5e7eb", paddingTop: 10 }}>
                        <div style={{ fontWeight: 600, marginBottom: 4 }}>{t("bbox.help.overlayTitle")}</div>
                        <div><kbd>B</kbd> · {t("bbox.help.toggleBoxes")}</div>
                        <div><kbd>P</kbd> · {t("bbox.help.toggleMask")}</div>
                        <div style={{ marginTop: 6 }}>{t("bbox.photoComment.moveHint")}</div>
                        <div style={{ color: "#64748b", marginTop: 4 }}>{t("bbox.help.overlayGuard")}</div>
                    </div>
                    {mode === "edit" && (
                        <div>
                            <div style={{ fontWeight: 600, marginBottom: 4 }}>
                                {t("bbox.help.shortcutsTitle")}
                            </div>
                            <ul style={{ margin: 0, paddingLeft: 18 }}>
                                <li><b>1</b>: {t("bbox.help.shortcuts.line")}</li>
                                <li><b>2</b>: {t("bbox.help.shortcuts.bbox")}</li>
                                <li><b>A</b>: {t("bbox.help.shortcuts.rect")}</li>
                                <li><b>Mouse Drag</b>: {t("bbox.help.shortcuts.pan")}</li>
                                <li><b>Wheel</b>: {t("bbox.help.shortcuts.zoom")}</li>
                            </ul>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default CanvasHelpPanel;